// extracted by mini-css-extract-plugin
export default {"container":"Details_container__CX2+q","cards":"Details_cards__VROqR","card":"Details_card__3qVKM","chain":"Details_chain__24to6","img":"Details_img__jFzYb"};